module.exports = __webpack_public_path__ + "img/Logo.23126011.svg";